<div class="Flex--row Statistikmonitor">


    <FloatingWindow @closeButtonClick="showGlossary=false" v-if="showGlossary" title="Glossar" :dockButton="false" :show.sync="showGlossary" :fullscreenWindow="true">
        <iframe :src="glossaryUrl" style="width:100%;height:100%"/>
    </FloatingWindow>



    <div class="Flex--col Card hide-on-print" style="padding:20px;min-width:320px;max-width:320px">
        <h3>Themenbereich:</h3>


        <select v-model="category" class="Input">
            <option v-if="category==null" :value="null">Bitte wählen</option>
            <option v-for="category in getCategoriesWithIndicatorTypes(['A', 'R'])" :value="category">{{category}}</option>
        </select>


        <template v-if="category != null">

            <h3>Indikatortyp:</h3>
            <div class="InputGroup" v-if="indicatorsExistFor(category, 'A') && indicatorsExistFor(category, 'R')">
                <Superbutton v-model="indicatorType" set="R" label="Relativ" />
                <Superbutton v-model="indicatorType" set="A" label="Absolut" />
            </div>
            <template v-else-if="indicatorsExistFor(category, 'A')">
                Nur Absolutwerte verfügbar
            </template>
            <template v-else-if="indicatorsExistFor(category, 'R')">
                Nur Relativwerte verfügbar
            </template>

            <h3>Indikator:</h3>
            <select v-model="indicator" class="Input">
                <option v-if="indicator==null" :value="null">Bitte wählen</option>
                <option v-for="idc in getIndicators(category, indicatorType)" :value="idc">{{idc.name}}</option>
            </select>

            <template v-if="indicator != null">


                <p>
                  
                    <Superbutton label="Glossar" icon="tivigi/img/question.svg" @click="openGlossary(getGlossaryLink(indicator.code))" alt="Glossar zum Themenbereich öffnen" title="Glossar zum Themenbereich öffnen" />
                </p>

                <template v-if="indicator != null">
                    <p>
                        <Superbutton label="Drucken" icon="/img/print.svg" :set="true" @click="print()" />
                    </p>
                    <p style="margin-top:0px;font-size:0.9em">Empfohlen wird der Druck im Querformat.</p>
                </template>


            </template>

        </template>

    </div>

    <div class="Flex--col Card" style="padding:20px">

        <h1 class="hide-on-screen">STATISTIKMONITOR Rhein-Neckar</h1>
        <h1>Raumeinheiten im Vergleich</h1>
        <template v-if="indicator != null">

            <h2>{{indicator.name}}</h2>


            <!--########################### BEGIN Table mode ##################################-->
            <table v-if="displayMode=='table'" class="Table">
                <tr>
                    <th>Raumeinheit</th>
                    <th v-for="year in getYears(indicator.code)" class="numeric">
                        {{year}}
                    </th>
                    <!-- NOTE: This is a hack to "push" the data columns to the left -->
                    <th style="width:100%"></th>
                </tr>

                <tr v-for="su in spatialUnitsBasismodul" :class="getCssClass(su)">

                    <td style="white-space: nowrap;">{{su.properties.name}}</td>
                    <td v-for="year in getYears(indicator.code)" class="numeric" style="width:20%">
                        {{getValue(su, indicator.code, year) | formatNumber(indicator.decimal_places)}}
                    </td>
                    <!-- NOTE: This is a hack to "push" the data columns to the left -->
                    <td style="width:100%"></td>
                </tr>

            </table>
            <!--########################### END Table mode ##################################-->

            <template v-if="displayMode == 'chart'">

                <div v-if="getYears(indicator.code).length > 1" class="InputGroup hide-on-print" style="margin:10px 0;">
                    <Superbutton v-for="(year,index) in getYears(indicator.code)" :label="year" v-model="selectedYear" :set="year" :unset="selectedYear" />
                </div>

                <template v-if="selectedYear != null">
                    <table class="Table">
                        <tr>
                            <th>Raumeinheit</th>
                            <th astyle="width:80%;"></th>
                            <th astyle="width:10%;" class="numeric">{{selectedYear}}</th>
                        </tr>

                        <tr v-for="su in spatialUnitsBasismodul" :class="getCssClass(su)">
                            <td style="white-space: nowrap;">{{su.properties.name}}</td>

                            <td>
                                <BarDisplay style="width:100%" :value="getValue(su, indicator.code, selectedYear)" :max="max" min="0" />
                            </td>
                            <td class="numeric">
                                {{getValue(su, indicator.code, selectedYear) | formatNumber(indicator.decimal_places)}}
                            </td>

                        </tr>
                    </table>
                </template>

            </template>




        </template>
        <template v-else>
            <p class="Statistikmonitor__Hint">Bitte wählen Sie zuerst einen Themenbereich.</p>
        </template>
    </div>

</div>